import { useSelector } from 'react-redux';
import { gamesListsSelectors } from '@box/redux/games';

export const useCurrentGameList = (id) => {
  const list = useSelector((state) => gamesListsSelectors.byId(state, id));

  return list;
};
